import { graphql } from 'relay-runtime';

export const getStudentsWithSkillStates = graphql`
  query AssignmentStudentsWithSkillStatesQuery($classIds: [ID!]!, $skillId: ID!) {
    studentSkillAndEssentialPredecessorsProgress(classIds: $classIds, targetSkillId: $skillId) {
      student {
        id
        firstName
        lastName
        publicUserId
        classes {
          id
        }
      }
      skillStatuses {
        skill {
          id
          name
          code
        }
        isPassedOrInferred
        readinessScore
      }
    }
  }
`;

export const createAssignment = graphql`
  mutation AssignmentCreateAssignmentMutation($input: CreateAssignmentInput!) {
    createAssignment(input: $input) {
      assignmentNode {
        id
      }
      errors {
        ... on ArgumentError {
          message
          paramName
        }
        ... on UnauthorizedAccessError {
          message
        }
      }
    }
  }
`;

export const getAssignments = graphql`
  query AssignmentGetAssignmentsQuery(
    $filter: AssignmentsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $order: [AssignmentSortInput!]
    $skip: Boolean = false
  ) {
    assignments(filter: $filter, first: $first, last: $last, after: $after, before: $before, order: $order)
      @skip(if: $skip) {
      nodes {
        id
        name
        dueOn
        startedOn
        createdBy {
          firstName
          lastName
          id
        }
        skill {
          id
          name
          code
        }
        classes {
          id
          name
          section
          owner {
            lastName
          }
        }
        studentSkillAssignments(filter: { isActive: ACTIVE }) {
          id
          submittedOn
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const getAssignmentStudentDashboard = graphql`
  query AssignmentGetAssignmentStudentDashboardQuery(
    $filter: AssignmentsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $order: [AssignmentSortInput!]
    $skip: Boolean = false
  ) {
    assignments(filter: $filter, first: $first, last: $last, after: $after, before: $before, order: $order)
      @skip(if: $skip) {
      nodes {
        id
        name
        dueOn
        startedOn
        createdBy {
          firstName
          lastName
          id
        }
        skill {
          id
          name
          code
        }
        classes {
          id
          name
        }
        studentSkillAssignments(filter: { isActive: ACTIVE }) {
          id
          submittedOn
        }
      }

      totalCount
    }
  }
`;

export const getStudentAssignment = graphql`
  query AssignmentStudentAssignmentQuery($assignmentId: ID!, $skip: Boolean = false) {
    assignment(assignmentId: $assignmentId) @skip(if: $skip) {
      id
      name
      dueOn
      createdBy {
        id
        firstName
        lastName
      }
      skill {
        id
        name
        code
      }
    }
    studentSkillAssignments(filter: { assignmentId: $assignmentId, isActive: ACTIVE }) {
      nodes {
        id
        submittedOn
        skill {
          id
          name
          code
        }
        skillAssessment {
          score
        }
      }
    }
  }
`;

export const getAssignmentReport = graphql`
  query AssignmentMonitoringQuery($assignmentId: ID!) {
    assignmentProgressPercentages(assignmentId: $assignmentId) {
      supportSkillAllCompleted
      supportSkillPending
      supportSkillSomeInProgress
      targetSkillFinished
      targetSkillNotStarted
    }
    assignment(assignmentId: $assignmentId) {
      id
      skill {
        id
        name
        code
        skillAncestries(filter: { skillRelevanceIds: ["SkillRelevanceNode:3"] }) {
          ancestorSkill {
            id
            name
            code
          }
        }
      }
      studentSkillAssignments {
        id
        submittedOn
        skillAssessment {
          id
          score
        }
        user {
          id
          firstName
          lastName
          publicUserId
        }
        skill {
          id
        }
      }
    }
  }
`;

export const getAssignmentStudentList = graphql`
  query AssignmentsStudentListQuery($assignmentId: ID!, $type: AssignmentProgressDetailType!) {
    assignmentProgressPercentageDetail(assignmentId: $assignmentId, assignmentProgressDetailType: $type) {
      id
      firstName
      lastName
      publicUserId
    }
  }
`;

export const updateAssignment = graphql`
  mutation AssignmentUpdateMutation($input: UpdateAssignmentInput!) {
    updateAssignment(input: $input) {
      assignmentNode {
        id
      }
    }
  }
`;

export const cancelAssignment = graphql`
  mutation AssignmentCancelMutation($assignmentId: ID!) {
    cancelAssignment(input: { assignmentId: $assignmentId }) {
      assignmentNode {
        id
      }
    }
  }
`;

export const getAssignmentStatusCounts = graphql`
  query AssignmentStatusCountsQuery($allFilter: AssignmentsFilterInput!, $activeFilter: AssignmentsFilterInput!) {
    allAssignments: assignments(filter: $allFilter, first: 1) {
      totalCount
    }
    activeAssignments: assignments(filter: $activeFilter, first: 1) {
      totalCount
    }
  }
`;

export const getSkillFilterOptions = graphql`
  query AssignmentSkillFilterOptionsQuery($filter: AllSkillsFilterInput, $first: Int) {
    allSkills(filter: $filter, first: $first, order: [{ name: ASC }]) {
      nodes {
        id
        name
        code
      }
    }
  }
`;
